import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { RangeFeature } from "src/app/model/catalog/catalog.model";
import { LensSide, LensType } from "src/app/model/configuration/configuration";
import { GlobalStorageService } from "src/app/service-utils/global-storage.service";
import { i18nService } from "src/app/service-utils/i18n.service";
import { ValidatorService } from "src/app/service-utils/validator-service";

@Component({
    selector: 'app-over-refraction',
    templateUrl: './over-refraction.component.html',
    styleUrls: ['./over-refraction.component.scss']
})
export class OverRefractionComponent implements OnInit {

    @Input() side: LensSide;

    LensType = LensType;
    form: FormGroup;

    isAxisDisable: boolean = true;
    isHSADisable: boolean = true;
    isStabilizationDisable: boolean = true;

    constructor(private i18nService: i18nService,
                private formBuilder: FormBuilder,
                private validatorService: ValidatorService,
                private globalStorageService: GlobalStorageService) {}

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            sphere: ["", [this.validatorService.numericValidator('Sphere2'), this.validatorService.requiredFieldValidator('Sphere2'), this.validatorService.rangeValidator(new RangeFeature('Sphere', true, -50, 50, 0.25))]],
            cylinder: [0, [this.validatorService.numericValidator('Cylinder'), this.validatorService.requiredFieldValidator('Cylinder'), this.validatorService.rangeValidator(new RangeFeature('Cylinder', true, -20, 20, 0.25))]],
            axis: [{value: '', disabled: true}, [this.validatorService.numericValidator('Axis'), this.validatorService.requiredFieldValidator('Axis'), this.validatorService.rangeValidator(new RangeFeature('Axis', true, 0, 179, 1))]],
            hsa: [{value: this.globalStorageService.hsa, disabled: true}, [this.validatorService.numericValidator('HSA'), this.validatorService.requiredFieldValidator('HSA'), this.validatorService.rangeValidator(new RangeFeature('HSA', true, 5, 35, 1))]],
            stabilization: [{value: '', disabled: true}, [this.validatorService.numericValidator('Stabilization'), this.validatorService.requiredFieldValidator('Stabilization'), this.validatorService.rangeValidator(new RangeFeature('Stabilization', true, 0, 179, 1))]],
        });
        this.initHandlerForm();
    }

    public initHandlerForm() {
        this.form.get('sphere').valueChanges.subscribe(() =>{
            this.recalculateOverRefraction();
        });
    
        this.form.get('cylinder').valueChanges.subscribe(() =>{
            this.recalculateOverRefraction();
        });
    }

    private recalculateOverRefraction() {
        
        if(this.form.get('sphere').value !== null && this.form.get('cylinder').value !== null) {
            let sphere = this.i18nService.replaceFromCommaToDot(this.form.get('sphere').value);
            let cylinder = this.i18nService.replaceFromCommaToDot(this.form.get('cylinder').value);

            this.sphereCylinder(sphere, cylinder);
            this.sphereCylinderHSA(sphere, cylinder);
            this.sphereCylinderAxisStabilization(sphere, cylinder);
            this.sphereCylinderAxisHSAStabilization(sphere, cylinder);
        }
    }

    private sphereCylinder(sphere: number, cylinder: number) {
        if((sphere >= -3 && sphere <= 3) && cylinder === 0) {
            this.isAxisDisable = true;
            this.isHSADisable = true;
            this.isStabilizationDisable = true;

            this.form.get('axis').disable();
            this.form.get('hsa').disable();
            this.form.get('stabilization').disable();
        }
    }

    private sphereCylinderHSA(sphere: number, cylinder: number) {
        if((sphere > 3 || sphere < -3) && cylinder === 0) {
            this.isAxisDisable = true;
            this.isHSADisable = false;
            this.isStabilizationDisable = true;

            this.form.get('axis').disable();
            this.form.get('hsa').enable();
            this.form.get('stabilization').disable();
        }
    }
    
    private sphereCylinderAxisStabilization(sphere: number, cylinder: number) {
        let spherePlusCylinder = sphere + cylinder;
        if((spherePlusCylinder >= -3 && spherePlusCylinder <= 3) && cylinder !== 0 && (sphere < 3 || sphere > -3)) {
            this.isAxisDisable = false;
            this.isHSADisable = true;
            this.isStabilizationDisable = false;

            this.form.get('axis').enable();
            this.form.get('hsa').disable();
            this.form.get('stabilization').enable();
        }
    }
    
    private sphereCylinderAxisHSAStabilization(sphere: number, cylinder: number) {
        let spherePlusCylinder = sphere + cylinder;
        if( ((spherePlusCylinder > 3 || spherePlusCylinder < -3) && cylinder !== 0) || ((sphere > 3 || sphere < -3) && cylinder !== 0)) {
            this.isAxisDisable = false;
            this.isHSADisable = false;
            this.isStabilizationDisable = false;

            this.form.get('axis').enable();
            this.form.get('hsa').enable();
            this.form.get('stabilization').enable();
        }
    }

    checkRequiredFields() {

        Object.keys(this.form.controls).forEach(key => {
          if(this.form.controls[key].enabled && this.form.controls[key].value === '') {
            this.form.controls[key].markAsTouched();
            this.form.controls[key].setValue("");
          }
        });
        
      }

    getLimitsFormatted(rangeMin: number, rangeMax: number) {
        return this.i18nService.getLimitsFormatted(rangeMin, rangeMax);
    }

    setValueWithFormat(featureName: string, control: string) {
        this.form.controls[control].setValue(
            this.i18nService.replaceFromDotToComma(
                this.i18nService.formatIfNumber(this.form.controls[control].value, this.globalStorageService.decimalFormats.find(feature => feature.featureName === featureName)?.decimalFormat)
            )
        );
    }
    
    clearAll() {
        this.form.get('cylinder').setValue(0);
        this.form.get('hsa').setValue(this.globalStorageService.hsa);
        
        this.isAxisDisable = true;
        this.isHSADisable = true;
        this.isStabilizationDisable = true;
    }
}